(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["responsive-iframe"] && !Shopify.designMode) return;
  try {
    
  class IframeEmbed extends HTMLElement {
    constructor() {
      super();
      this.iframe = null;
      this.boundListener = this.handleMessage.bind(this);
    }

    connectedCallback() {
      this.iframe = this.querySelector('.iframe-embed__iframe');
      if (this.iframe) {
        window.addEventListener('message', this.boundListener);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('message', this.boundListener);
    }

    handleMessage(event) {
      if (event.source !== this.iframe.contentWindow || !event.data) return;

      if (typeof event.data.iframeHeight !== 'undefined') {
        this.iframe.style.height = event.data.iframeHeight + 'px';
      }

      if (event.data.type === 'devacurl:add-to-cart') {
        this.addToCart(event);
      }

      if (event.data.type === 'devacurl:analytics-event') {
        this.pushAnalyticsEvent(event);
      }
    }

    // Forwards an analytics event posted by the embedded page to GTM's
    // dataLayer. The embedded page posts:
    //   { type: 'devacurl:analytics-event', event: 'curl_quiz_next',
    //     params: { event_label: '...' } }
    // Any event name works, so new events need no theme change.
    pushAnalyticsEvent(event) {
      // Only accept events from the configured URL's origin, in case the
      // iframe has navigated somewhere else
      if (event.origin !== new URL(this.iframe.src).origin) return;

      var name = event.data.event;
      if (typeof name !== 'string' || !/^[A-Za-z][A-Za-z0-9_]{0,63}$/.test(name)) return;

      var payload = { event: name };
      var params = event.data.params;
      if (params && typeof params === 'object' && !Array.isArray(params)) {
        Object.keys(params).forEach(function(key) {
          var value = params[key];
          // Flat primitives only, and never let the iframe override 'event'
          if (key === 'event') return;
          if (['string', 'number', 'boolean'].indexOf(typeof value) === -1) return;
          payload[key] = value;
        });
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    // Adds { id, quantity } items posted by the embedded page, then lets the
    // theme refresh the cart count and open the quick cart. The outcome is
    // posted back as 'devacurl:add-to-cart:result'.
    addToCart(event) {
      var reply = function(result) {
        event.source.postMessage(
          Object.assign({ type: 'devacurl:add-to-cart:result' }, result),
          event.origin
        );
      };

      // Only accept cart requests from the configured URL's origin, in case
      // the iframe has navigated somewhere else
      if (event.origin !== new URL(this.iframe.src).origin) return;

      var items = this.sanitizeItems(event.data.items);
      if (!items) {
        reply({ ok: false, message: 'Invalid items' });
        return;
      }

      fetch(window.theme.routes.cart.add + '.js', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(res) {
          return res.json().then(function(body) {
            if (!res.ok) {
              reply({ ok: false, message: body.description || body.message });
              return;
            }
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
            reply({ ok: true, items: body.items });
          });
        })
        .catch(function() {
          reply({ ok: false, message: 'Network error' });
        });
    }

    sanitizeItems(items) {
      if (!Array.isArray(items) || !items.length) return null;

      var sanitized = items.map(function(item) {
        var id = Number(item && item.id);
        var quantity = Number(item && item.quantity);
        if (!Number.isInteger(id) || id <= 0) return null;
        if (!Number.isInteger(quantity) || quantity <= 0) return null;
        return { id: id, quantity: quantity };
      });

      return sanitized.indexOf(null) === -1 ? sanitized : null;
    }
  }

  customElements.define('iframe-embed', IframeEmbed);

  } catch(e) { console.error(e); }
})();
})();
